/**
 * The plumber quote request the landing page offers as an example.
 *
 * Pressing a suggestion chip is not a brief somebody wrote, it is somebody saying "show me one of
 * those". They get this: instantly, at no cost, and identical every time. Typing their own words
 * into the box is the thing that means a real build, see Hero.jsx on the landing side.
 *
 * The JSON is compiled output, what the builder itself writes from these screens. It was
 * produced by running an authoring spec through flow-core's own `expandSpec` and `compile`
 * rather than typed by hand, and the test holds it to that: hydrate then compile must return it
 * unchanged, so it can never drift into something the builder would not have written.
 */
export const PLUMBER_QUOTE = {
  id: 'plumber-quote',
  brief: 'A quote request for a plumber: the job, the address, photos and when to visit',
  reply: 'Here is a three-step quote request: the job and what is happening, then the address with optional photos and when suits, then how to reach you. Photos are the part that turns a guess into a price. Tell me your trade and area and I will make it yours, or send it to your phone and fill it in as a customer would.',
  name: 'Plumber quote requests',
  flowJson: {
  "version": "7.3",
  "screens": [
    {
      "id": "screen_a",
      "title": "What needs doing?",
      "layout": {
        "type": "SingleColumnLayout",
        "children": [
          {
            "type": "TextBody",
            "text": "Tell us the job and we will come back with a price."
          },
          {
            "type": "RadioButtonsGroup",
            "name": "job",
            "label": "What is the job?",
            "required": true,
            "data-source": [
              {
                "id": "leak",
                "title": "Leak or burst pipe"
              },
              {
                "id": "boiler",
                "title": "Boiler or heating"
              },
              {
                "id": "bathroom",
                "title": "Bathroom or kitchen fitting"
              },
              {
                "id": "blockage",
                "title": "Blocked drain or toilet"
              },
              {
                "id": "other",
                "title": "Something else"
              }
            ]
          },
          {
            "type": "TextArea",
            "name": "detail",
            "label": "What is happening?",
            "required": true,
            "helper-text": "A sentence is plenty"
          },
          {
            "type": "Footer",
            "label": "Continue",
            "on-click-action": {
              "name": "navigate",
              "next": {
                "type": "screen",
                "name": "screen_b"
              }
            }
          }
        ]
      }
    },
    {
      "id": "screen_b",
      "title": "Where and when",
      "layout": {
        "type": "SingleColumnLayout",
        "children": [
          {
            "type": "TextInput",
            "name": "address",
            "label": "Address",
            "input-type": "text",
            "required": true
          },
          {
            "type": "PhotoPicker",
            "name": "photos",
            "label": "Photos of the problem",
            "max-uploaded-photos": 5,
            "max-file-size-kb": 8192
          },
          {
            "type": "RadioButtonsGroup",
            "name": "when",
            "label": "When suits a visit?",
            "required": true,
            "data-source": [
              {
                "id": "emergency",
                "title": "As soon as possible"
              },
              {
                "id": "week",
                "title": "This week"
              },
              {
                "id": "flexible",
                "title": "I am flexible"
              }
            ]
          },
          {
            "type": "Footer",
            "label": "Continue",
            "on-click-action": {
              "name": "navigate",
              "next": {
                "type": "screen",
                "name": "screen_c"
              }
            }
          }
        ]
      }
    },
    {
      "id": "screen_c",
      "title": "How to reach you",
      "layout": {
        "type": "SingleColumnLayout",
        "children": [
          {
            "type": "TextInput",
            "name": "full_name",
            "label": "Your name",
            "input-type": "text",
            "required": true
          },
          {
            "type": "TextInput",
            "name": "phone",
            "label": "Phone number",
            "input-type": "phone",
            "required": true
          },
          {
            "type": "Footer",
            "label": "Send quote request",
            "on-click-action": {
              "name": "complete",
              "payload": {
                "job": "${screen.screen_a.form.job}",
                "detail": "${screen.screen_a.form.detail}",
                "address": "${screen.screen_b.form.address}",
                "photos": "${screen.screen_b.form.photos}",
                "when": "${screen.screen_b.form.when}",
                "full_name": "${form.full_name}",
                "phone": "${form.phone}"
              }
            }
          }
        ]
      },
      "terminal": true
    }
  ],
  "routing_model": {
    "screen_a": [
      "screen_b"
    ],
    "screen_b": [
      "screen_c"
    ]
  }
},
};
